import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const useCountdownTimer = (endTimestamp: number) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!endTimestamp) {
      setTimeLeft(0);
      return () => {};
    }

    const calculateTimeLeft = () => {
      const now = dayjs();
      const end = dayjs(endTimestamp);
      const diff = end.diff(now, 'millisecond');
      return Math.max(0, Math.ceil(diff / 1000));
    };

    setTimeLeft(calculateTimeLeft());

    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();

      if (newTimeLeft <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
      } else {
        setTimeLeft(newTimeLeft);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTimestamp]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  if (timeLeft <= 0) {
    return null;
  }

  return formatTime(timeLeft);
};

export default useCountdownTimer;
